// SidebarContext — shares sidebar hover/expand state across layout components
// DashboardLayout reads isExpanded to push main content; Sidebar writes it.

import { createContext, useContext, useState } from 'react';

const SidebarContext = createContext({ isExpanded: false, setIsExpanded: () => {} });

export const useSidebar = () => useContext(SidebarContext);

export function SidebarProvider({ children }) {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <SidebarContext.Provider value={{ isExpanded, setIsExpanded }}>
      {children}
    </SidebarContext.Provider>
  );
}
